import { serializeFiltersForApi } from '@/utils/filters'
import VueValuesStore from '@/vue3-values/main'

export default {
    computed: {
        visualizationFilters() {
            return VueValuesStore.value.get('visualizationFilters')
        },
        visualizationFiltersProcessId() {
            return VueValuesStore.value.get('visualizationFiltersProcessId')
        },
        generalOperator() {
            const operator = VueValuesStore.value.get('generalOperator')
            return operator || 'AND'
        },
    },
    methods: {
        getActiveFiltersApiParts(filtersList = this.visualizationFilters) {
            const { filters, filterSetsUUIDs, generalOperator } = this.splitFilterAndFilterSets(filtersList || [])
            return {
                filters,
                filterSets: filterSetsUUIDs,
                operator: generalOperator,
            }
        },
        buildVisualizationParams(baseParams = {}, { filtersList } = {}) {
            const parts = this.getActiveFiltersApiParts(
                filtersList === undefined ? this.visualizationFilters : filtersList,
            )
            return {
                ...(baseParams || {}),
                ...parts,
            }
        },
        setVisualizationFilters(selected) {
            VueValuesStore.value.set('visualizationFilters', selected)
        },
        setVisualizationFiltersForProcess(processId, selected) {
            this.setVisualizationFiltersProcessId(processId)
            this.setVisualizationFilters(selected)
        },
        setGeneralOperator(operator) {
            VueValuesStore.value.set('generalOperator', operator)
        },
        setVisualizationFiltersProcessId(processId) {
            const normalized = processId === undefined || processId === null ? null : `${processId}`
            VueValuesStore.value.set('visualizationFiltersProcessId', normalized)
        },
        appendVisualizationFiltersForProcess(processId, newFilters) {
            const cached = this.visualizationFilters || []
            const normalizedNew = Array.isArray(newFilters) ? newFilters : [newFilters]
            this.setVisualizationFiltersForProcess(processId, [...cached, ...normalizedNew])
        },
        addVisualizationFilters(selected) {
            const { visualizationFilters } = this
            VueValuesStore.value.set('visualizationFilters', [...(visualizationFilters || []), selected])
        },
        addMultipleFilters(allSelected) {
            const { visualizationFilters } = this
            VueValuesStore.value.set('visualizationFilters', [...(visualizationFilters || []), ...allSelected])
        },
        updateFilters(filters) {
            const cached = this.visualizationFilters || []
            const formattedFilters = cached.map((f) => (f.uuid === filters.uuid ? { ...f, toDelete: true } : f))
            this.setVisualizationFilters(formattedFilters)
        },
        resetStorage(processId) {
            VueValuesStore.value.set('visualizationFilters', [])
            if (processId !== undefined && processId !== null) {
                this.setVisualizationFiltersProcessId(`${processId}`)
            } else {
                this.setVisualizationFiltersProcessId(null)
            }
        },
        formatFiltersParam(filters = []) {
            const sanitizedFilters = (filters || [])
                .filter((f) => !f.pending)
                .filter((f) => f.id !== 'FILTER_SET')
            return serializeFiltersForApi(sanitizedFilters)
        },
        splitFilterAndFilterSets(totalFilters) {
            const onlyFilters = (totalFilters || []).filter((filter) => filter.id !== 'FILTER_SET')
            const filterSets = (totalFilters || []).filter((filter) => filter.id === 'FILTER_SET')
            const filterSetsUUIDs = filterSets
                .map((filterSet) => filterSet.uuid || (Array.isArray(filterSet.values) ? filterSet.values[0] : undefined))
                .filter(Boolean)
            const filters = this.formatFiltersParam(onlyFilters)
            const { generalOperator } = this
            return { filters, filterSetsUUIDs, generalOperator }
        },
    },
}
